import { AfterViewInit, Component, ViewChild, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { ServicesService } from '../../../services/services.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";


export interface UserSDRData {
    id: string;
    sdrNumber: string;
    type: string,
    status: string,
    createdDate: string;
    lastModifiedDate: string;
    description: string;
    responsibleBy: string;
    addedBy: string;
    mandays: number;
    startDate: string;
    endDate: string;

}


@Component({
  selector: 'app-services-sdrs',
  templateUrl: './services-sdrs.component.html',
  styleUrls: ['./services-sdrs.component.scss']
})
export class ServicesSdrsComponent implements AfterViewInit {

    displayedColumns: string[] = ['sdr', 'addby', 'mandays', 'lastmodifieddate'];
    dataSource: MatTableDataSource<UserSDRData>;

    @ViewChild(MatPaginator)
    paginator!: MatPaginator;
    @ViewChild(MatSort)
    sort!: MatSort;

    pagecode: string = "serv-all-sdr";
    module: string = "services";
    allSDRs: Array<UserSDRData> = [];

    accessdenied: boolean = false;
    isLoading: boolean = true;
    loadingMessage: string = "Loading...";

    constructor(private route: ActivatedRoute, private _router: Router,
        private authentication: AuthenticationService,
        private common: CommonService,
        private servicesService: ServicesService) {

        this.dataSource = new MatTableDataSource(this.allSDRs);
        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {


                        var pageURL = this._router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        // load page data
                        this.getUserServices(1);
                        //

                        window.scroll(0, 0);

                    }
                    else
                        this.accessdenied = true;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });




    }
    sdrStatus: any = [
        {
            "name": "All",
            "code": "all",
            "isActive": true,
            "active_background_color": "#00a6b6",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "#00a6b6"
        },
        {
            "name": "New",
            "code": "new",
            "isActive": false,
            "active_background_color": "blue",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "blue"
        },
        {
            "name": "Planned",
            "code": "planned",
            "isActive": false,
            "active_background_color": "orange",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "orange"
        },
        {
            "name": "In Progress",
            "code": "inprogress",
            "isActive": false,
            "active_background_color": "green",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "green"
        },
        {
            "name": "Need confirmation",
            "code": "waitingforapproval",
            "isActive": false,
            "active_background_color": "red",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "red"
        },
        {
            "name": "Completed",
            "code": "completed",
            "isActive": false,
            "active_background_color": "grey",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "grey"
        }

    ];
    applyStatusFilter(statusCode: any) {
        if (statusCode === 'all') {
            this.dataSource = new MatTableDataSource(this.allSDRs);
        }
        else if (statusCode == 'new') {
            var filteredArray: UserSDRData[] = this.allSDRs.filter(s => s.status == 'New');
            this.dataSource = new MatTableDataSource(filteredArray);
        }
        else if (statusCode == 'inprogress') {
            var filteredArray: UserSDRData[] = this.allSDRs.filter(s => s.status.toLowerCase().includes('progress'));
            this.dataSource = new MatTableDataSource(filteredArray);
        }
        else if (statusCode == 'waitingforapproval') {
            var filteredArray: UserSDRData[] = this.allSDRs.filter(s => s.status.toLowerCase().includes('confirmation'));
            this.dataSource = new MatTableDataSource(filteredArray);
        }
        else if (statusCode == 'completed') {
            var filteredArray: UserSDRData[] = this.allSDRs.filter(s => s.status.toLowerCase().includes('completed'));
            this.dataSource = new MatTableDataSource(filteredArray);
        }
        else if (statusCode == 'planned') {
            var filteredArray: UserSDRData[] = this.allSDRs.filter(s => s.status.toLowerCase().includes('planned'));
            this.dataSource = new MatTableDataSource(filteredArray);
        }

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        for (var i = 0; i < this.sdrStatus.length; i++) {
            if (this.sdrStatus[i].code === statusCode)
                this.sdrStatus[i].isActive = true;
            else
                this.sdrStatus[i].isActive = false;
        }

    }
    getUserServices(page: any) {
        this.servicesService.getUserServices(this.authentication._authentication.id, page).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data.length > 0) {

                        for (var i = 0; i < res.data.length; i++) {
                            var resp = "";
                            if (res.data[i].SDR_Responsible__r) {
                                resp = res.data[i].SDR_Responsible__r.Name;
                            }

                            var addedBy = "";
                            if (res.data[i].Contact__r) {
                                addedBy = res.data[i].Contact__r.Name;
                            }

                            //some sdrs saved with null Work_Order_Description__c
                            if (res.data[i].Work_Order_Description__c == null)
                                res.data[i].Work_Order_Description__c = "";


                            // requested by Georges on 22/9/2022 by email - SDP Terminology Change
                            if (res.data[i].Status__c.toLowerCase() === "Awaiting For Initial Approval".toLowerCase())
                                res.data[i].Status__c = "Confirmation to Start the Work";
                            else if (res.data[i].Status__c.toLowerCase() === "Awaiting For Final Approval".toLowerCase())
                                res.data[i].Status__c = "Completion Confirmation";

                            this.allSDRs.push({
                                id: res.data[i].Id,
                                sdrNumber: res.data[i].Name,
                                type: res.data[i].Type__c,
                                status: res.data[i].Status__c,
                                createdDate: res.data[i].CreatedDate,
                                lastModifiedDate: res.data[i].LastModifiedDate,
                                description: res.data[i].Work_Order_Description__c,
                                responsibleBy: resp,
                                addedBy: addedBy,
                                mandays: res.data[i].Consumed_Man_Days__c,
                                startDate: res.data[i].Start_Date__c,
                                endDate: res.data[i].End_Date__c,
                            });
                        }
                        this.dataSource = new MatTableDataSource(this.allSDRs);
                        this.dataSource.paginator = this.paginator;
                        this.dataSource.sort = this.sort;
                        this.loadingMessage = "No services found";

                        if (res.data.length > 0)
                            this.getUserServices(page + 1);
                    }
                    else
                        this.isLoading = false;
                }
                else {
                    this.common.ShowMessage("error", res.error_message, '');
                    this.isLoading = false;
                }
            },
            (err: any) => {
                console.error('Web/Support/Dashboard/getUserCases()', err);
            }
        );
    }

    clickedRows(row: any) {
        this._router.navigate(['/services/service-sdr-details/' + row.id]);
    }

    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
    splitText(text: any): string {
        if (text.length > 100)
            return text.substring(0, 100) + "...";
        else
            return text;
    }

}